import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UserInfo} from '../../../../projects/api/src/user/user.model';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ProfileApiService} from '../../../../projects/api/src/user/profile/profile-api.service';

@Injectable()
export class ProfileResolver  {
  constructor(private api: ProfileApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserInfo> | Promise<UserInfo> | UserInfo {
    return this.api.readProfile();
  }

}
